export const DEFAULT_ASSIGN = 'DEFAULT_ASSIGN';
export const STATE_INIT = 'STATE_INIT';
export const SEARCH_PARAM = 'SEARCH_PARAM';
export const SELECTED_ROW = 'SELECTED_ROW';
export const SET_FORM = 'SET_FORM';
export const STATE_PARAM = 'STATE_PARAM';
export const GRID_ROW_INIT = 'GRID_ROW_INIT';
export const PAGING_INFO = 'PAGING_INFO';
export const SEARCH_POPUP_STATE_INIT = 'SEARCH_POPUP_STATE_INIT';
export const SEARCH_POPUP_COMM_INIT = 'SEARCH_POPUP_COMM_INIT';
export const RE_INS_POPUP_PARAMS = 'RE_INS_POPUP_PARAMS';
export const SEARCH_BARCODE_RESULT = 'SEARCH_BARCODE_RESULT';
export const BARCODE_SEARCH_INIT = 'BARCODE_SEARCH_INIT';

export default {
	STATE_INIT,
	DEFAULT_ASSIGN,
	SEARCH_PARAM,
	SELECTED_ROW,
	SET_FORM,
	STATE_PARAM,
	GRID_ROW_INIT,
	PAGING_INFO,
	SEARCH_POPUP_STATE_INIT,
	SEARCH_POPUP_COMM_INIT,
	RE_INS_POPUP_PARAMS,
	SEARCH_BARCODE_RESULT,
	BARCODE_SEARCH_INIT
};
